import React from "react";
import { Box, Typography } from "@mui/material";
import { NumberField } from "@base-ui/react";
import { useTranslation } from "react-i18next";

interface AverageWeightInputProps {
  value: number | null;
  onChange: (value: number | null) => void;
}

export function AverageWeightInput({
  value,
  onChange,
}: AverageWeightInputProps) {
  const { t, i18n } = useTranslation();

  return (
    <Box
      sx={{
        mb: 3,
        p: 2,
        mt: 4,
        bgcolor: "background.paper",
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography
        variant="subtitle2"
        fontWeight="bold"
        mb={1}
        color="text.primary"
      >
        {`${t("text.calibrate.average_weight")} (${t("text.required")})`}
      </Typography>

      <NumberField.Root
        value={value}
        onValueChange={onChange}
        style={{ width: "100%" }}
        locale={i18n.language}
      >
        <Box
          component={NumberField.Group}
          sx={{
            display: "flex",
            alignItems: "center",
            border: 1,
            borderColor: "var(--color-border-strong)",
            borderRadius: 1.5,
            bgcolor: "background.paper",
            overflow: "hidden",
            "&:focus-within": {
              borderColor: "primary.main",
              boxShadow: "0 0 0 1px var(--color-primary)",
            },
          }}
        >
          <NumberField.Input
            id="average-weight-input"
            style={{
              flexGrow: 1,
              padding: "8.5px 14px",
              border: "none",
              outline: "none",
              fontSize: "0.875rem",
              fontFamily: "inherit",
              backgroundColor: "transparent",
            }}
          />
          <Box
            sx={{
              px: 1.5,
              color: "text.secondary",
              typography: "body2",
              display: "flex",
              alignItems: "center",
            }}
          >
            {t("text.grams")}
          </Box>
        </Box>
      </NumberField.Root>
    </Box>
  );
}
